import LocomotiveScroll from 'locomotive-scroll';
import { gsap } from "gsap";
/*import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);*/

jQuery(document).ready(function($) {
  

	
 var $window = $(window),
	  body = $('body'),
	  deviceAgent = navigator.userAgent.toLowerCase(),
	  isMobile = deviceAgent.match(/(iphone|ipod|android|iemobile)/),
	  isMobileAlt = deviceAgent.match(/(iphone|ipod|ipad|android|iemobile)/),
	  isAppleDevice = deviceAgent.match(/(iphone|ipod|ipad)/),
	  sIEMobile = deviceAgent.match(/(iemobile)/),
	  isSafari = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1 &&  navigator.userAgent.indexOf('Android') == -1,
    windowW = $window.width(),
	  header = $('.header'),
    headerH = 80;
	
	// DÉTECTION DE LA PLATEFORME (desktop, ios ou android)
		var device = "desktop";
		// ios
		var i = 0,
			iOS = false,
			iDevice = ['iPad', 'iPhone', 'iPod'];
		for ( ; i < iDevice.length ; i++ ) {
			if( navigator.platform === iDevice[i] ){ device = "ios"; break; }
		}
		// android
		var ua = navigator.userAgent.toLowerCase();
		var android = ua.indexOf("android") > -1;
		if(android){device = "android";$("body").addClass("android");}
	// fin détection
	
	if(device == "ios" || device == "android"){
		// IOS ET ANDROID
       $("body").addClass("mobile");
	} else {
		// DESKTOP SEULEMENT
		$("body").addClass("desktop");
		
    if ( $(".accueil" ).length ) {
    
       /******RELOAD ON RESIZE *******/
      $(window).resize(function(){location.reload();});
      
    }

	}
	
	/* detect touch */
	if("ontouchstart" in window){
		document.documentElement.className = document.documentElement.className + " touch";
	}
	
  
     /****** LOAD ANIMATION *******/
    
    $(window).load(function() {
        $('body').addClass('loaded');
    });
    
  
  /****** LOCOMOTIVE *******/
  
  const locomotiveScroll = new LocomotiveScroll({
      lenisOptions: {
          wrapper: window,
          content: document.documentElement,
          lerp: 0.1,
          duration: 1,
          orientation: 'vertical',
          gestureOrientation: 'vertical',
          smoothWheel: true,
          smoothTouch: false,
          wheelMultiplier: 1,
          touchMultiplier: 2,
          normalizeWheel: true,
          autoResize: true,
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
      },
  });
  
  
  /****** ANIMATIONS *******/
  
  
  if ( $(".accueil" ).length ) {
  

    /*locomotiveScroll.on("scroll", ScrollTrigger.update);
    ScrollTrigger.addEventListener("refresh", () => locomotiveScroll.update());
    ScrollTrigger.refresh();*/
    
    
    
    const $service = document.querySelector(".accueil__services__web");
    const $service2 = document.querySelector(".accueil__services__design");
    const $service3 = document.querySelector(".accueil__services__video-anim");
    const $scale_spinner_projets = document.querySelector(".arrow-spinner-projets");
    const $scale_spinner = document.querySelector(".arrow-spinner");
    
    const tl = gsap.timeline({ paused: true });
    const tl2 = gsap.timeline({ paused: true });
    const tl3 = gsap.timeline({ paused: true });
    const tl_spinner_projets = gsap.timeline({ paused: true });
    const tl_spinner = gsap.timeline({ paused: true });
    
    tl.to($service, { xPercent:-100, duration: 1, ease: "0.4, 0, 0, 1" });
    tl2.to($service2, { xPercent:-100, duration: 1, ease: "0.4, 0, 0, 1" });
    tl3.to($service3, { xPercent:-100, duration: 1, ease: "0.4, 0, 0, 1" });
    tl_spinner_projets.to($scale_spinner_projets, { rotation:360, duration: 1, ease: "0.4, 0, 0, 1" });
    tl_spinner.to($scale_spinner, { rotation:360, duration: 1, ease: "0.4, 0, 0, 1" });
    
    
    /* Progress Events */
    
    window.addEventListener("progressEvent", (e) => {
      const { progress } = e.detail;
      /* Update timeline progress */
      tl.progress(progress);
    });

     window.addEventListener("progressEvent2", (e) => {
      const { progress } = e.detail;
      /* Update timeline progress */
      tl2.progress(progress);
    });

     window.addEventListener("progressEvent3", (e) => {
      const { progress } = e.detail;
      /* Update timeline progress */
      tl3.progress(progress);
    });
    
     window.addEventListener("progressSpinner_projets", (e) => {
      const { progress } = e.detail;
      /* Update timeline progress */
      tl_spinner_projets.progress(progress);
    });
    
    
    window.addEventListener("progressSpinner", (e) => {
      const { progress } = e.detail;
      /* Update timeline progress */
      tl_spinner.progress(progress);
    });
    
   
  
	}
  
  
   /**** Changement du header au scroll ****/
	
    var scroll = $window.scrollTop();
 		if (scroll >= 100) {
   			body.addClass('header-changed');
        } else {
 			body.removeClass('header-changed');
		}
    
	$window.scroll(function() {
	   var scroll = $window.scrollTop();
 		if (scroll >= 100) {
   			body.addClass('header-changed');
        } else {
 			  body.removeClass('header-changed');
		}
	});
	
    

  /****** SCROLLTO *******/

    $('a[href*="#"]:not([href="#"]):not(.btn-horaire)').click(function () {
     
       headerH = $('.header').height();
      
       if($("body").hasClass("mobile-menu_open")) {
            $('body').removeClass('mobile-menu_open');
       }

       
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html,body').animate({ scrollTop: target.offset().top - headerH }, 500 );
            return false;
          }
        }
    });

  
  var hashLink = window.location.hash;
   if ($(hashLink).length) { 
        if(windowW >= 1200) { 
            headerH = 172;
       } else {
            headerH = 80;
       }
       //window.scroll(0,0);
       setTimeout( function() {
           $('html, body').animate({  scrollTop: $(window.location.hash).offset().top - headerH }, 500);
       });
   }

    
    /****** MENU MOBILE ******/

    
    $(document).on('click', '.menu__btn', function() {
        $('body').toggleClass('mobile-menu_open');
        return false;
    });
    
    

    /****** ACCORDEON ******/
    
   $('.accordeon .accordeon-nav').on('click', function() {		
		var $this = $(this);
		
		if($this.parent().hasClass("open")) {
			$('.accordeon').removeClass('open');
		} else {    
			$('.accordeon').removeClass('open');
			$this.parent().addClass('open');
		}   
       
	});
    
    
	
}); 